/**
 * The above type defines options for a message, including the message content, whether it should be
 * sent, whether it should be hidden in chat, and the structure of the message.
 */
export type MessageOptions = {
    msg: string;
    shouldSend?: boolean;
    hideInChat?: boolean;
    messageStructure?: any;
}